import React, { useEffect, useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import SiteService from '../../../services/siteService';
import { PharmacyContext } from '../../central-pharmacy/pharmacyContext';
import PharmacyReportsPage from '../../central-pharmacy/pages/PharmacyReportsPage';
import { AdminPageHeader } from '../ui';
import AdminReportsDomainNav from './AdminReportsDomainNav';
import '../../head-doctor/HeadDoctorDashboard.css';
import '../../central-pharmacy/CentralPharmacy.css';
import './AdminClinicalAnalyticsLayout.css';

/**
 * Rapports pharmacie centrale dans l’admin — même page que /pharmacy-central/rapports,
 * avec contexte sites minimal (tous sites par défaut).
 */
export default function AdminPharmacyReportsPage() {
  const { toast: layoutToast } = useOutletContext() || {};
  const toast = layoutToast || (() => {});
  const [workSites, setWorkSites] = useState([]);
  const [workSiteId, setWorkSiteId] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await SiteService.getActiveSites();
        if (!cancelled && res.success && Array.isArray(res.data)) {
          setWorkSites(res.data);
        }
      } catch {
        if (!cancelled) setWorkSites([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      workSites,
      workSiteId,
      setWorkSiteId,
      centralSite: null,
      toast,
      reloadNonce: 0,
      bumpReload: () => {},
      mode: 'central'
    }),
    [workSites, workSiteId, toast]
  );

  return (
    <div className="adm-analytics-page hd-reports-page">
      <AdminPageHeader
        badge="Administration"
        title="Rapports pharmacie"
        description="Synthèse des dispensations, ordonnances délivrées et classements médicaments — vue pharmacie centrale."
      />
      <AdminReportsDomainNav />

      <PharmacyContext.Provider value={value}>
        <PharmacyReportsPage embedded />
      </PharmacyContext.Provider>
    </div>
  );
}
